const MutationTypes = {
  SET_CURRENT_VIEW: "SET_CURRENT_VIEW",
  CLEAR_CURRENT_VIEW: "CLEAR_CURRENT_VIEW",
  SET_ENTITY_SCORING_STATUS: "SET_ENTITY_SCORING_STATUS",
};

const initialState = {
  currentView: null,
  entityScoringEnabled: {},
};

const state = { ...initialState };

const mutations = {
  [MutationTypes.SET_CURRENT_VIEW](state, currentView) {
    state.currentView = currentView;
  },

  [MutationTypes.CLEAR_CURRENT_VIEW](state) {
    state.currentView = null;
  },

  [MutationTypes.SET_ENTITY_SCORING_STATUS](state, { entityType, enabled }) {
    state.entityScoringEnabled = {
      ...state.entityScoringEnabled,
      [entityType]: enabled,
    };
  },
};

const actions = {
  setCurrentView({ commit }, currentView) {
    commit(MutationTypes.SET_CURRENT_VIEW, currentView);
  },

  clearCurrentView({ commit }) {
    commit(MutationTypes.CLEAR_CURRENT_VIEW);
  },

  setEntityScoringStatus({ commit }, { entityType, enabled }) {
    commit(MutationTypes.SET_ENTITY_SCORING_STATUS, { entityType, enabled });
  },
};

const getters = {
  getCurrentView: (state) => state.currentView,
  getEntityScoringEnabled: (state) => (entityType) => {
    return state.entityScoringEnabled[entityType] || false;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
